import Phone from "@assets/icons/phone";
import { StatusBlock, StatusBlockType } from "@components/status-block";
import { useDevices } from "@features/device";
import classNames from "classnames";
import { useEffect, useMemo } from "react";
import styles from "./devices.module.scss";

type Props = {
  deviceId: string;
  className?: string;
  onClick?: () => void;
};

export const Device = ({ deviceId, className, onClick }: Props) => {
  const { state, getDeviceMessages } = useDevices();

  const device = useMemo(
    () => state.devices[deviceId],
    [deviceId, state.devices]
  );

  useEffect(() => {
    if (deviceId && !device && !state.loadingMessages && !state.errorMessages) {
      getDeviceMessages(deviceId);
    }
  }, [
    device,
    deviceId,
    getDeviceMessages,
    state.errorMessages,
    state.loadingMessages,
  ]);

  if (!device) {
    return null;
  }

  return (
    <BaseDevice
      onClick={onClick}
      className={className}
      name={device.name}
      status={device.active ? "active" : "inactive"}
    />
  );
};

type BaseDeviceProps = Pick<Props, "onClick" | "className"> & {
  name: string;
  status: "active" | "inactive" | "select";
};

export const BaseDevice = ({
  onClick,
  className,
  status,
  name,
}: BaseDeviceProps) => {
  return (
    <div
      onClick={onClick}
      className={classNames(
        styles.device,
        onClick && styles.clickable,
        className
      )}
    >
      <div className={styles.left}>
        <Phone />
        <span>{name || "Не выбран"}</span>
      </div>
      {status !== "select" && (
        <StatusBlock
          text={status === "active" ? "В сети" : "Не в сети"}
          type={
            status === "active"
              ? StatusBlockType.Success
              : StatusBlockType.Warning
          }
        />
      )}
    </div>
  );
};
